//Components
import Layout from '../../hocs/Layout';
import { useEffect, useState } from 'react';
import { PriceForm } from '../../components/aditional/PriceForm';
//Styles
import '../../styles/services.css';


const Branding = () => {

	const [openPriceForm, setOpenPriceForm] = useState(false);
	
	const toggleOpenForm = () => {
    	setOpenPriceForm(!openPriceForm);
    }

	useEffect(() => {
		window.scrollTo(0,0);
	}, []);

	return (

		<Layout>
			<div className='container-webd-header'>
				<h3 className='title-max'>Diseño de Marca</h3>
				<p className='webd-header-text'>Creamos identidades de marca únicas y a la medida de empresas y emprendedores</p>
				<div className='contain-webd-boxes'>
					<div className='webd-box'>
						<img src={require(`../../images/paleta-color.webp`)} alt='paleta-color' />
						<h4>Paleta de colores unica</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/tipografia.webp`)} alt='tipografia' />
						<h4>Tipografia a la medida</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/adds-design.webp`)} alt='diseño' />
						<h4>Diseño de logotipo original</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/papeleria.webp`)} alt='papeleria' />
						<h4>Papeleria corporativa</h4>
					</div>
				</div>
			</div>
			<div className='container-webd-process'>
				<h3 className='home-titles-white'>Nuestro proceso</h3>
				<div className='container-process-boxes'>
	      			<div className='container-process-box'>
						<img src={require(`../../images/briefing.webp`)} alt='briefing'  className='process-img' />
						<h3 className='process-text'>Briefing y análisis</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/conceptual.webp`)} alt='conceptual'  className='process-img' />
						<h3 className='process-text'>Conceptualizar</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/diseno-3d.webp`)} alt='diseño-3d'  className='process-img' />
						<h3 className='process-text'>Diseño y feedback</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/entrega.webp`)} alt='entrega'  className='process-img' />
						<h3 className='process-text'>Entrega de archivos</h3>
					</div>
	    		</div>
    		</div>
			<div className='container-webd-examples'>
				<h3 className='home-titles'>Algunos de nuestros trabajos</h3>
				<div className='contain-webd-examples'>
					<img src={require(`../../images/la-curva.webp`)} alt='lacurva'  className='examples-img' />
					<img src={require(`../../images/logorbm.webp`)} alt='rbm'  className='examples-img' />
					<img src={require(`../../images/transporte.webp`)} alt='transporte'  className='examples-img' />
					<img src={require(`../../images/hey-divina.webp`)} alt='hey-divina'  className='examples-img' />
					<img src={require(`../../images/ferreteria-sur.webp`)} alt='ferreteria-sur'  className='examples-img' />
				</div>
				<button className='btn btn1' onClick={toggleOpenForm} style={{textDecoration:'none'}}>Solicitar una cotización</button>
			</div>
			<PriceForm toggleOpen={toggleOpenForm} openPriceForm={openPriceForm} />
		</Layout>
	);
};

export default Branding